import React, { useContext, useEffect, useState } from "react";
import "../../../TutorGreen.css";
import { initializeApp } from "firebase/app";
import { getDownloadURL, getStorage, ref, uploadBytes } from "firebase/storage";
import { AuthContextTwo } from "../../../../../../contexts/AuthProviderTwo";
import toast from "react-hot-toast";
import { Link } from "react-router-dom";
import LoaderSmall from "../../../../../Shared/LoderSmall/LoaderSmall";

const firebaseConfig = {
  apiKey: "AIzaSyDHqLpPVzd0Y9SWTpSH1smRmbKv4WUvi-4",
  authDomain: "tutors-today-student.firebaseapp.com",
  projectId: "tutors-today-student",
  storageBucket: "tutors-today-student.appspot.com",
  messagingSenderId: "171808622362",
  appId: "1:171808622362:web:cb9ad091e01bba89988ea3",
};

const app = initializeApp(firebaseConfig);
const storage = getStorage(app);

const ModalEducational = ({ isVisible, onClose, profileData }) => {
  const { userTwo } = useContext(AuthContextTwo);
  const [loading, setLoading] = useState(false); // Loading state

  const [file, setFile] = useState([]); // Assuming useState is used for state management
  const [honsFiles, setHonsFiles] = useState([]);
  const [DegreeFiles, setDegreeFiles] = useState([]);
  const [isSSCgroupValid, setIsSSCgroupValid] = useState(true);
  const [isHSCgroupValid, setIsHSCgroupValid] = useState(true);
  const [isHSCresultValid, setIsHSCresultValid] = useState(true);
  const [isHonsInstituteValid, setIsHonsInstituteValid] = useState(true);
  const [isHonsSemesterValid, setIsHonsSemesterValid] = useState(true);
  const [isHonsMajorValid, setIsHonsMajorValid] = useState(true);

  const [formData, setFormData] = useState({
    SSCgroup: "",
    SSCinstitute: "",
    HSCgroup: "",
    HSCinstitute: "",
    HSCresult: "",
    HonsInstitute: "",
    HonsSemester: "",
    HonsMajor: "",
    MastersInstitute: "",
    MastersSemester: "",
    MastersMejor: "",
    fileUrls1: "",
    fileUrls2: "",
    fileUrls3: "",
    HonsFileUrls1: "",
    HonsFileUrls2: "",
    HonsFileUrls3: "",
    DegreeFileUrls1: "",
    DegreeFileUrls2: "",
    DegreeFileUrls3: "",
  });

  const handleFileChange = (event) => {
    const uploadedFiles = event.target.files;

    if (uploadedFiles.length > 0) {
      const fileLabels = Array.from(uploadedFiles)
        .map((file) => file.name)
        .join(", ");

      document.getElementById("fileLabel").innerText = fileLabels;
      setFile(Array.from(uploadedFiles));
    } else {
      document.getElementById("fileLabel").innerText = "JPG / PNG / PDF";
      setFile([]);
    }
  };

  const handleFileChangeHons = (event) => {
    const uploadedFiles = event.target.files;

    if (uploadedFiles.length > 0) {
      const fileLabels = Array.from(uploadedFiles)
        .map((file) => file.name)
        .join(", ");

      document.getElementById("honsFileLabel").innerText = fileLabels; // Update the label for Hons files
      setHonsFiles(Array.from(uploadedFiles)); // Assuming you have a state for Hons files
    } else {
      document.getElementById("honsFileLabel").innerText = "JPG / PNG / PDF";
      setHonsFiles([]);
    }
  };
  const handleFileChangeDegree = (event) => {
    const uploadedFiles = event.target.files;

    if (uploadedFiles.length > 0) {
      const fileLabels = Array.from(uploadedFiles)
        .map((file) => file.name)
        .join(", ");

      document.getElementById("DegreeFileLabel").innerText = fileLabels; // Update the label for Hons files
      setDegreeFiles(Array.from(uploadedFiles)); // Assuming you have a state for Hons files
    } else {
      document.getElementById("DegreeFileLabel").innerText = "JPG / PNG / PDF";
      setDegreeFiles([]);
    }
  };

  const handleUpload = () => {
    setLoading(true);

    // Validation checks
    const isAnyProfileValid = profileData.some(
      (profile) =>
        profile.SSCgroup &&
        profile.HSCgroup &&
        profile.HSCresult &&
        profile.HonsSemester &&
        profile.HonsInstitute &&
        profile.HonsMajor
    );

    const isFormDataValid =
      formData.SSCgroup &&
      formData.HSCgroup &&
      formData.HSCresult &&
      formData.HonsSemester &&
      formData.HonsInstitute &&
      formData.HonsMajor;

    // Update state for validation flags
    setIsSSCgroupValid(
      formData.SSCgroup || profileData.some((profile) => profile.SSCgroup)
    );
    setIsHSCgroupValid(
      formData.HSCgroup || profileData.some((profile) => profile.HSCgroup)
    );
    setIsHSCresultValid(
      formData.HSCresult || profileData.some((profile) => profile.HSCresult)
    );
    setIsHonsInstituteValid(
      formData.HonsInstitute ||
        profileData.some((profile) => profile.HonsInstitute)
    );
    setIsHonsSemesterValid(
      formData.HonsSemester ||
        profileData.some((profile) => profile.HonsSemester)
    );
    setIsHonsMajorValid(
      formData.HonsMajor || profileData.some((profile) => profile.HonsMajor)
    );

    // If no profile or formData is valid, show an error and stop execution
    if (
      !isSSCgroupValid &&
      !isHSCgroupValid &&
      !isHSCresultValid &&
      !isHonsSemesterValid &&
      !isHonsInstituteValid &&
      !isHonsMajorValid
    ) {
      setLoading(false);
      return;
    }

    if (!isAnyProfileValid && !isFormDataValid) {
      toast.error("Please fill up all the required fields.");
      setLoading(false);
      return; // Stop further execution
    }

    const promises = [];
    const updatedFormData = { ...formData }; // Copy the existing formData

    // Function to upload a single file
    const uploadFile = (uploadedFile, formDataKey, storagePath) => {
      const storageRef = ref(storage, `${storagePath}/${uploadedFile.name}`);
      return uploadBytes(storageRef, uploadedFile)
        .then((snapshot) => getDownloadURL(snapshot.ref))
        .then((downloadURL) => {
          updatedFormData[formDataKey] = downloadURL;
          return downloadURL;
        });
    };

    // Upload regular files
    file.forEach((uploadedFile, index) => {
      promises.push(
        uploadFile(uploadedFile, `fileUrls${index + 1}`, "uploads")
      );
    });

    // Upload Hons files
    honsFiles.forEach((uploadedFile, index) => {
      promises.push(
        uploadFile(uploadedFile, `HonsFileUrls${index + 1}`, "uploads")
      );
    });

    // Upload Degree files
    DegreeFiles.forEach((uploadedFile, index) => {
      promises.push(
        uploadFile(uploadedFile, `DegreeFileUrls${index + 1}`, "uploads")
      );
    });

    Promise.all(promises)
      .then(() => {
        console.log("Files uploaded successfully (if any)!");
        setFormData(updatedFormData); // Update the state with new file URLs
        updateDataOnServer(updatedFormData); // Update server data regardless of file upload
        toast.success("Data submitted successfully!");
      })
      .catch((error) => {
        console.error("Error uploading files: ", error);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const updateDataOnServer = async (dataToUpdate) => {
    const updateUrl = "https://tutor-tree-server-1.vercel.app/user/updateImageTwo";
    const updateResponse = await fetch(updateUrl, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        email: userTwo.email,
        ...dataToUpdate, // Use the updated data
      }),
    });

    const updateData = await updateResponse.json();
    console.log("Data updated on the server:", updateData);
  };

  const handleInputChange = (event) => {
    const { name, value } = event.target;

    // Update the specific input field without affecting other fields
    setFormData((prevFormData) => ({
      ...prevFormData,
      [name]: value,
    }));
  };

  //////////////////////// select options /////////////////////////////

  const [districts, setDistricts] = useState([]);

  const fetchDistricts = async () => {
    try {
      const response = await fetch("https://tutor-tree-server-1.vercel.app/allDistrict");
      const data = await response.json();
      setDistricts(data);
    } catch (error) {
      console.error("Error fetching Districts:", error);
    }
  };

  useEffect(() => {
    fetchDistricts();
  }, []);

  const [dropdownVisible, setDropdownVisible] = useState(false);
  const options = [
    "Govt. Commerce College",
    "Chittagong College",
    "Chittagong Govt. Women's College",
    "Agrabad Mohila Colleg",
    "Chittagong Cantonment Public College",
    "Government City College, Chittagong",
    "Government Hazi Mohammad Mohsin College, Chittagong",
    "Chittagong BGMEA Institute of Fashion & Technology (CBIFT)",
    "Chittagong Physical Education College",
    "Chittagong Law College",
  ];
  const handleInputChangeTwo = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });

    if (value === "") {
      setDropdownVisible(false);
    } else {
      setDropdownVisible(true);
    }
  };

  const handleOptionClick = (option) => {
    setFormData({ ...formData, HSCinstitute: option });
    setDropdownVisible(false); // Hide dropdown after selection
  };

  const filteredOptions =
    formData.HSCinstitute === ""
      ? []
      : options.filter((option) =>
          option.toLowerCase().includes(formData.HSCinstitute.toLowerCase())
        );

  ///////////// Institute Hons

  const [dropdownVisibleUniversityHons, setDropdownVisibleUniversityHons] =
    useState(false);
  const optionsUniversityHons = [
    "University of Dhaka",
    "BRAC University",
    "Bangladesh University of Engineering and Technology",
    "Rajshahi University",
    "National University, Bangladesh",
    "North South University",
    "Daffodil International University",
    "American International University-Bangladesh",
    "University of Chittagong",
    "Shahjalal University of Science and Technology",
    "Independent University, Bangladesh",
    "Ahsanullah University of Science and Technology",
    "Bangladesh Agricultural University",
    "East West University",
    "Jahangirnagar University",
    "United International University",
    "Asian University for Women",
    "Islamic University of Technology",
    "International Islamic University, Chittagong",
    "Bangabandhu Sheikh Mujib Medical University",
    "Khulna University of Engineering and Technology",
    "Bangladesh University of Professionals",
    "Stamford University Bangladesh",
    "University of Liberal Arts Bangladesh",
    "Khulna University",
    "University of Asia Pacific",
    "International University of Business Agriculture and Technology",
    "Southeast University, Bangladesh",
    "Jagannath University",
    "Bangladesh University of Textiles",
    "Islamic University",
    "Bangabandhu Sheikh Mujibur Rahman Agricultural University",
    "Chittagong University of Engineering and Technology",
    "University of Barisal",
    "Bangladesh University of Business and Technology",
    "Chittagong Veterinary and Animal Sciences University",
    "Rajshahi University of Engineering and Technology",
    "Noakhali Science and Technology University",
    "Dhaka University of Engineering and Technology",
    "Bangabandhu Sheikh Mujibur Rahman Science and Technology University",
    "Green University of Bangladesh",
    "Canadian University of Bangladesh",
    "Jashore University of Science and Technology",
    "ASA University Bangladesh",
    "Sher-e-Bangla Agricultural University",
    "Hajee Mohammad Danesh Science and Technology University",
    "Primeasia University",
    "Sylhet Agricultural University",
    "Dhaka International University",
    "Patuakhali Science and Technology University",
    "BGMEA University of Fashion and Technology",
    "Mawlana Bhashani Science and Technology University",
    "Comilla University",
    "University of Science and Technology Chittagong",
    "Sonargaon University",
    "Metropolitan University",
    "State University of Bangladesh",
    "Northern University of Bangladesh",
    "Eastern University, Bangladesh",
    "World University of Bangladesh",
    "Manarat International University",
    "Begum Rokeya University, Rangpur",
    "University of Information Technology and Sciences",
    "Asian University of Bangladesh",
    "Leading University",
    "Bangabandhu Sheikh Mujibur Rahman Maritime University",
    "Jatiya Kabi Kazi Nazrul Islam University",
    "Notre Dame University Bangladesh",
    "Shanto Mariam University of Creative Technology",
    "East Delta University",
    "Gono Bishwabidyalay",
    "Islamic Arabic University",
    "Presidency University, Bangladesh",
    "Pabna Science and Technology University",
    "Prime University",
    "City University",
    "First Capital University of Bangladesh",
    "University of Development Alternative",
    "University of Global Village",
    "Sheikh Fazilatunnesa Mujib University",
    "Bangladesh University",
    "Atish Dipankar University of Science and Technology",
    "Uttara University",
    "University of South Asia, Bangladesh",
    "Chittagong Independent University",
    "Chittagong Medical University",
    "Royal University of Dhaka",
    "Premier University",
    "Port City International University",
    "Varendra University",
    "Southern University Bangladesh",
    "European University of Bangladesh",
    "Sylhet International University",
    "Queens University",
    "IBAIS University",
    "ZNRF University of Management Sciences",
    "Sheikh Hasina University",
    "North East University Bangladesh",
    "Fareast International University",
    "The Millenium University",
    "The People's University of Bangladesh",
    "Victoria University of Bangladesh",
    "Begum Gulchemonara Trust University",
    "Rangamati Science and Technology University",
    "The International University of Scholars",
    "Bangamata Sheikh Fojilatunnesa Mujib Science and Technology University",
    "University of Creative Technology Chittagong",
    "Rabindra University, Bangladesh",
    "Anwer Khan Modern University",
    "Rajshahi Science and Technology University",
    "North Western University",
    "Bangladesh Islami University",
    "Rajshahi Medical University",
    "Hamdard University of Bangladesh",
    "German University Bangladesh",
    "Northern University of Business and Technology, Khulna",
    "Central Women's University",
    "N.P.I. University of Bangladesh",
    "Feni University",
    "Rabindra Maitree University",
    "Ranada Prasad Shaha University",
    "Ishakha International University, Bangladesh",
    "Khulna Agricultural University",
    "North Bengal International University",
    "Pundra University of Science and Technology",
    "Bangladesh University of Health Sciences",
    "Khwaja Yunus Ali University",
    "International Standard University",
    "Bandarban University",
    "Global University Bangladesh",
    "Sylhet Medical University",
    "CCN University of Science and Technology",
    "Times University of Bangladesh",
    "Britannia University",
    "Cox's Bazar International University",
    "Z.H. Sikder University of Science and Technology",
    "Central University of Science and Technology",
    "Exim Bank Agricultural University of Bangladesh",
    "Govt. Commerce College",
    "Chittagong College",
    "Chittagong Govt. Women's College",
    "Agrabad Mohila College",
    "Chittagong Cantonment Public College",
    "Government City College, Chittagong",
    "Government Hazi Mohammad Mohsin College, Chittagong",
    "Chittagong BGMEA Institute of Fashion & Technology (CBIFT)",
    "Chittagong Physical Education College",
    "Chittagong Law College",
  ];
  const handleInputChangeUniversityHons = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });

    if (value === "") {
      setDropdownVisibleUniversityHons(false);
    } else {
      setDropdownVisibleUniversityHons(true);
    }
  };

  const handleOptionClickUniversityHons = (option) => {
    setFormData({ ...formData, HonsInstitute: option });
    setDropdownVisibleUniversityHons(false); // Hide dropdown after selection
  };

  const filteredOptionsUniversityHons =
    formData.HonsInstitute === ""
      ? []
      : optionsUniversityHons.filter((option) =>
          option.toLowerCase().includes(formData.HonsInstitute.toLowerCase())
        );

  ///////////// Institute Hons

  const [
    dropdownVisibleUniversityMasters,
    setDropdownVisibleUniversityMasters,
  ] = useState(false);
  const optionsUniversityMasters = [
    "University of Dhaka",
    "BRAC University",
    "Bangladesh University of Engineering and Technology",
    "Rajshahi University",
    "National University, Bangladesh",
    "North South University",
    "Daffodil International University",
    "American International University-Bangladesh",
    "University of Chittagong",
    "Shahjalal University of Science and Technology",
    "Independent University, Bangladesh",
    "Ahsanullah University of Science and Technology",
    "Bangladesh Agricultural University",
    "East West University",
    "Jahangirnagar University",
    "United International University",
    "Asian University for Women",
    "Islamic University of Technology",
    "International Islamic University, Chittagong",
    "Bangabandhu Sheikh Mujib Medical University",
    "Khulna University of Engineering and Technology",
    "Bangladesh University of Professionals",
    "Stamford University Bangladesh",
    "University of Liberal Arts Bangladesh",
    "Khulna University",
    "University of Asia Pacific",
    "International University of Business Agriculture and Technology",
    "Southeast University, Bangladesh",
    "Jagannath University",
    "Bangladesh University of Textiles",
    "Islamic University",
    "Bangabandhu Sheikh Mujibur Rahman Agricultural University",
    "Chittagong University of Engineering and Technology",
    "University of Barisal",
    "Bangladesh University of Business and Technology",
    "Chittagong Veterinary and Animal Sciences University",
    "Rajshahi University of Engineering and Technology",
    "Noakhali Science and Technology University",
    "Dhaka University of Engineering and Technology",
    "Bangabandhu Sheikh Mujibur Rahman Science and Technology University",
    "Green University of Bangladesh",
    "Canadian University of Bangladesh",
    "Jashore University of Science and Technology",
    "ASA University Bangladesh",
    "Sher-e-Bangla Agricultural University",
    "Hajee Mohammad Danesh Science and Technology University",
    "Primeasia University",
    "Sylhet Agricultural University",
    "Dhaka International University",
    "Patuakhali Science and Technology University",
    "BGMEA University of Fashion and Technology",
    "Mawlana Bhashani Science and Technology University",
    "Comilla University",
    "University of Science and Technology Chittagong",
    "Sonargaon University",
    "Metropolitan University",
    "State University of Bangladesh",
    "Northern University of Bangladesh",
    "Eastern University, Bangladesh",
    "World University of Bangladesh",
    "Manarat International University",
    "Begum Rokeya University, Rangpur",
    "University of Information Technology and Sciences",
    "Asian University of Bangladesh",
    "Leading University",
    "Bangabandhu Sheikh Mujibur Rahman Maritime University",
    "Jatiya Kabi Kazi Nazrul Islam University",
    "Notre Dame University Bangladesh",
    "Shanto Mariam University of Creative Technology",
    "East Delta University",
    "Gono Bishwabidyalay",
    "Islamic Arabic University",
    "Presidency University, Bangladesh",
    "Pabna Science and Technology University",
    "Prime University",
    "City University",
    "First Capital University of Bangladesh",
    "University of Development Alternative",
    "University of Global Village",
    "Sheikh Fazilatunnesa Mujib University",
    "Bangladesh University",
    "Atish Dipankar University of Science and Technology",
    "Uttara University",
    "University of South Asia, Bangladesh",
    "Chittagong Independent University",
    "Chittagong Medical University",
    "Royal University of Dhaka",
    "Premier University",
    "Port City International University",
    "Varendra University",
    "Southern University Bangladesh",
    "European University of Bangladesh",
    "Sylhet International University",
    "Queens University",
    "IBAIS University",
    "ZNRF University of Management Sciences",
    "Sheikh Hasina University",
    "North East University Bangladesh",
    "Fareast International University",
    "The Millenium University",
    "The People's University of Bangladesh",
    "Victoria University of Bangladesh",
    "Begum Gulchemonara Trust University",
    "Rangamati Science and Technology University",
    "The International University of Scholars",
    "Bangamata Sheikh Fojilatunnesa Mujib Science and Technology University",
    "University of Creative Technology Chittagong",
    "Rabindra University, Bangladesh",
    "Anwer Khan Modern University",
    "Rajshahi Science and Technology University",
    "North Western University",
    "Bangladesh Islami University",
    "Rajshahi Medical University",
    "Hamdard University of Bangladesh",
    "German University Bangladesh",
    "Northern University of Business and Technology, Khulna",
    "Central Women's University",
    "N.P.I. University of Bangladesh",
    "Feni University",
    "Rabindra Maitree University",
    "Ranada Prasad Shaha University",
    "Ishakha International University, Bangladesh",
    "Khulna Agricultural University",
    "North Bengal International University",
    "Pundra University of Science and Technology",
    "Bangladesh University of Health Sciences",
    "Khwaja Yunus Ali University",
    "International Standard University",
    "Bandarban University",
    "Global University Bangladesh",
    "Sylhet Medical University",
    "CCN University of Science and Technology",
    "Times University of Bangladesh",
    "Britannia University",
    "Cox's Bazar International University",
    "Z.H. Sikder University of Science and Technology",
    "Central University of Science and Technology",
    "Exim Bank Agricultural University of Bangladesh",
    "Govt. Commerce College",
    "Chittagong College",
    "Chittagong Govt. Women's College",
    "Agrabad Mohila College",
    "Chittagong Cantonment Public College",
    "Government City College, Chittagong",
    "Government Hazi Mohammad Mohsin College, Chittagong",
    "Chittagong BGMEA Institute of Fashion & Technology (CBIFT)",
    "Chittagong Physical Education College",
    "Chittagong Law College",
  ];
  const handleInputChangeUniversityMasters = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });

    if (value === "") {
      setDropdownVisibleUniversityMasters(false);
    } else {
      setDropdownVisibleUniversityMasters(true);
    }
  };

  const handleOptionClickUniversityMasters = (option) => {
    setFormData({ ...formData, MastersInstitute: option });
    setDropdownVisibleUniversityMasters(false); // Hide dropdown after selection
  };

  const filteredOptionsUniversityMasters =
    formData.MastersInstitute === ""
      ? []
      : optionsUniversityMasters.filter((option) =>
          option.toLowerCase().includes(formData.MastersInstitute.toLowerCase())
        );

  ///////////// subjects Hons

  const [dropdownVisibleSubjectsHons, setDropdownVisibleSubjectsHons] =
    useState(false);
  const optionsSubjectsHons = [
    "Automobile",
    "Petroleum and Mining Engineering",
    "Fabric Manufacturing",
    "Power Supply",
    "Electronics & Communication Engineering (ECE)",
    "Agricultural Chemistry",
    "Home Economics",
    "Disaster Management",
    "Dentistry",
    "Fisheries and Aquaculture",
    "English Literature",
    "Agricultural Engineering and Technology",
    "Printing and Publication Studies",
    "Telecommunication Engineering",
    "English and Humanities",
    "Dance",
    "Music",
    "Physical Education and Sports Science",
    "Art and Creative Studies",
    "Software Engineering (SWE)",
    "Computer Technology",
    "Psychology",
    "Data Telecommunication and Networking",
    "Al-Quran",
    "Industrial Relations and Labour Studies",
    "Agronomy",
    "Geography",
    "Leather Engineering",
    "Plant Pathology",
    "Islamic History and Culture",
    "Agriculture",
    "Pharmaceutical Chemistry",
    "LLM",
    "English Language Teaching (ELT)",
    "Computer Science (CS)",
    "Applied Accounting",
    "Craft",
    "Bank Management",
    "Naval Architecture and Marine Engineering (NAME)",
    "Arabic",
    "Literature and Culture Studies",
    "Fisheries",
    "Electrical and Electronic Engineering (EEE)",
    "Electronics Technology",
    "Instrumental Music",
    "Climate Change and Development (CCD)",
    "Fisheries Science",
    "History",
    "Electronics",
    "Food and Nutrition",
    "Social Science",
    "Social Work",
    "Health Economics",
    "Peace and Conflict Studies",
    "Theoretical Physics",
    "Management Information Systems (MIS)",
    "Computer Engineering (CoE)",
    "Resource Management and Entrepreneurship",
    "Graphic Design",
    "Maritime Science",
    "Pharmaceutical Technology",
    "Entrepreneurship",
    "Anthropology",
    "Nuclear Engineering",
    "Organic Chemistry",
    "Sculpture",
    "Applied Chemistry and Chemical Engineering",
    "English Literature and Language",
    "Geography and Environment",
    "Public Health",
    "Geography and Environmental Studies",
    "Media Studies and Journalism",
    "Theoretical and Computational Chemistry",
    "Electronics and Telecommunication Engineering (ETE)",
    "English",
    "ACCA (the Association of Chartered Certified Accountants)",
    "Law and Justice",
    "Finance and Banking",
    "Pharmacology",
    "Industrial and Production Engineering (IPE)",
    "Oceanography",
    "Applied Mathematics",
    "Soil Science",
    "Business Studies",
    "Criminology",
    "Public Administration",
    "Chemistry",
    "Banking and Insurance",
    "Mathematics",
    "Sociology",
    "Geology",
    "Management",
    "Political Science",
    "Human Resource Management (HRM)",
    "Humanities",
    "Cachion Docianing and Technology",
    "Oriental Art",
    "Architecture",
    "International Relations (IR)",
    "Child Development and Social Relationship",
    "Supply Chain Management",
    "Civil Technology",
    "Shipbuilding Technology",
    "Arabic Language",
    "Hadith",
    "Fashion Designing and Technology (FDT)",
    "Physics",
    "Biochemistry",
    "Japanese Studies",
    "Information and Communication Engineering (ICE)",
    "Information and Communication Technology (ICT)",
    "Rabindra Sangeet",
    "ACCA",
    "Printmaking",
    "Agricultural Economics",
    "Economics",
    "Aeronautical Engineering",
    "Law",
    "Mechanical Engineering (ME)",
    "Building Engineering and Construction Management",
    "Physiotherapy",
    "Power Technology",
    "General",
    "Public Health and Informatics",
    "Accounting and Information Systems (AIS)",
    "Sanskrit",
    "Civil and Environmental Engineering (CEE)",
    "Microbiology",
    "Finance",
    "Nazrul Sangeet",
    "Statistics",
    "Apparel Manufacture and Technology (AMT)",
    "Marine Science",
    "Drawing and Painting",
    "Glass and Ceramic Engineering (GCE)",
    "Apparel Merchandising Management & Technology",
    "Education and Research (ER)",
    "Organization Strategy and Leadership (OSL)",
    "Tourism and Hospitality Management (THM)",
    "International Business (IB)",
    "World Religion and Culture (WRC)",
    "Theater and Music",
    "Languages and Linguistics",
    "Sanskrit and Pali",
    "Port Management and Logistics (PML)",
    "Disaster and Human Security Management (DHSM)",
    "Clothing and Textile",
    "Materials Science and Engineering (MSE)",
    "LLB",
    "Development Studies",
    "Information Technology (IT)",
    "Accounting",
    "Marketing",
    "Marine Tourism and Hospitality Management (MTHM)",
    "Maritime Law (ML)",
    "Port & Shipping Management (PSM)",
    "Environmental Technology Engineering (ETE)",
    "Materials and Metallurgical Engineering (MME)",
    "Disaster Resilience and Sustainable Development (DRSD)",
    "Electronic and Telecom Engineering (ETE)",
    "Environmental Science and Management (ESM)",
    "Environmental and Resource Management (ERM)",
    "Nuclear Power Engineering (NPE)",
    "Disaster Prevention and Urban Safety (DPUS)",
    "Water and Flood Management (WFM)",
    "Communication Disorders",
    "Mass Communication and Journalism (MCJ)",
    "Biomedical Physics and Technology (BPT)",
    "Clinical Pharmacy and Pharmacology (CPP)",
    "Pharmacy",
    "History of Art",
    "Dobotics and Mechatronics",
    "Civil Engineering (CE)",
    "Urban and Rural Planning (URP)",
    "Urban and Regional Planning (URP)",
    "Architecture & Interior Design Technology (AIDT)",
    "Architecture (Arch)",
    "Meteorology",
    "Geography and Environmental Science (GES)",
    "Television, Film and Photography",
    "Disaster Management and Vulnerability Studies (DMVS)",
    "Disaster Science and Management (DSM)",
    "Disaster Science & Management (DSM)",
    "Electromedical Engineering",
    "Electrical & Power Engineering (EPE)",
    "Energy Technology",
    "Naval Architecture and Offshore Engineering (NAOE)",
    "Robotics and Mechatronics Engineering (RME)",
    "Nuclear Science and Engineering (NSE)",
    "Educational Psychology",
    "Plant Breeding",
    "Genetic Engineering and Biotechnology (GEB)",
    "Medical Psychology",
    "Biochemistry and Molecular Biology (BMB)",
    "Petroleum and Mineral Resources Engineering (PMRE)",
    "Craft and Material Studies (CMS)",
    "Materials and Metallurgical Engineering (MME)",
    "Chemical Engineering (ChE)",
    "Mechanical and Chemical Engineering (MCE)",
    "Biomedical Engineering (BME)",
    "Water Resources Engineering (WRE)",
    "Computer Science and Engineering (CSE)",
    "Veterinary Medicine",
    "Agribusiness",
    "Textile Engineering (TE)",
    "Pathology",
    "Forensic Medicine",
    "Community Medicine",
    "Physiology",
    "Anatomy",
    "Mechatronics Engineering (ME)",
    "Classical Music",
    "Radiography",
    "Biochemistry and Biotechnology",
    "Folk Music",
    "Leather Products Engineering",
    "Recourse Management and Entrepreneurship (RME)",
    "Electronic and Telecom Engineering",
    "Biochemistry and Microbiology",
    "Alema",
    "Islamic Studies",
    "Mawlana",
    "Physical Science",
    "Soil, Water and Environment",
    "Finance and Marketing (Double Major)",
    "Zoology",
    "Takmil",
    "Computer Crionco and Insincorina",
    "Interior Architecture",
    "Building Engineering and Construction Management (BECM)",
    "Mechanical and Production Engineering (MPE)",
    "Fabric Engineering",
    "Marhalatul Mutawassitah",
    "Marhala Sanabiah Ulaiya",
    "Marhalatul Fadilat",
    "Geological Sciences",
    "Petroleum & Mining Engineering (PME)",
    "Hifzul Quran",
    "Mufti",
    "Dinajpur Zilla School",
    "Theology and Islamic Studies",
    "Chinese Language and Culture",
    "Electronics and Communication Engineering (ECE)",
    "Information Studies and Library Management",
    "Applied Physics, Electronics and Communication Engineering",
    "Environmental Science (ES)",
    "Holy Quran and Sunnah",
    "Industrial Engineering and Management (IEM)",
    "Law and Human Rights",
    "Architecture Technology",
    "French Language",
    "Computer Information Management (CIM) and Accounting",
    "General Electronics",
    "Dress Making",
    "Tafhim-ul-Quran",
    "Business and Technology Management (BTM)",
    "Moallim",
    "Marine Bio-Resource Science",
    "Applied Linguistics",
    "Dawaa and Civilization",
    "Horticulture",
    "North Indian Classical Music",
    "Islamic Law",
    "Botany",
    "Biotechnology",
    "Marine Bio-Resources Science",
    "Apparel Manufacturing and Management (AMM)",
    "Applied Nutrition and Food",
    "Islamic History",
    "Ispahani Public School and College",
    "Apparel Merchandising",
    "Al-Quran and Islamic Studies",
    "Marketing and Management",
    "Information System (MIS)",
    "Management Studies",
    "Genetics and Plant Breeding (GPB)",
    "Finance and Economics (Double Major)",
    "Photography",
    "Tabla",
    "Nanoscience and Nanotechnology",
    "Management Information Systems (MIS) and Finance (Double Major)",
    "Architecture and Interior Design Technology",
    "Management and Marketing (Double Major)",
    "Management of Technology (MOT)",
    "Computer",
    "Agrotechnology",
    "Agroforestry and Environmental Science",
    "Earth and Environmental Science (EES)",
    "Applied Statistics and Data Science (MSDS)",
    "Electrical Technology",
    "Clinical Pharmacy and Molecular Pharmacology",
    "Education",
    "Philosophy",
    "Veterinary and Animal Science",
    "Agribusiness and Marketing",
    "Applied Physics and Electronics (APE)",
    "Finance and Accounting",
    "Agronomy and Agricultural Extension",
    "English Literature and Theory",
    "Industrial-Organizational Psychology",
    "Chemical Engineering and Polymer Science (CEPS)",
    "Textile Machinery Design and Maintenance",
    "Human Resource Management (HRM) and Economics, Double Major",
    "Human Resource Management (HRM)",
    "International Business (IB), Double Major",
    "Electronics and Communication Engineering (ECE) and Applied Physics",
    "Electrical Engineering",
    "Advanced Engineering Management",
    "Finance and Human Resource Management (HRM)",
    "Jamia Arabia Imdadul Uloom",
    "Faridabad Madrasah",
    "Islamic Philology",
    "Biochemistry and Cell Biology",
    "Al-Hadith and Islamic Studies",
    "Telecommunication Technology",
    "Fashion Design and Technology (FDT)",
    "Computer Operation",
    "Java SE-8",
    "Electrical and Computer Engineering (ECE)",
    "Multimedia and Creative Technology (MCT)",
    "Management and Marketing (Double Major)",
    "Environmental and Resource Economics",
    "Strategic International Management",
    "Economics and Marketing (Double Major)",
    "Wet Processing Engineering (WPE)",
    "Finance and Accounting (Double Major)",
    "Cost and Management Accounting",
    "Drama and Dramatics",
    "Spanish Language",
    "Digital Business and Innovation (DBI)",
    "Renewable Energy Technology (RET)",
    "Craft and Fashion Design",
    "Women and Gender Studies",
    "Physical Chemistry",
    "Biotechnology and Genetic Engineering (BGE)",
    "Government and Politics",
    "Refrigeration and Air-Conditioning Technology",
    "Civil and Water Resources Engineering",
    "Industrial Engineering (IE)",
    "Chemical Engineering and Technics",
    "Biotechnology and Genetic Engineering (BTE)",
    "Mechanical and Electrical Engineering (MEE)",
    "Computer and Information Technology",
    "General Science",
    "Entomology",
    "Criminology and Police Science",
    "Arabic Language and Islamic Studies",
    "Modern Nazrana",
    "Film and Television",
    "Footwear Engineering",
    "Common Law",
    "Economics and Banking (EB)",
    "Accounting and Marketing (Double Major)",
    "Applied Physics and Electronic Engineering (APEE)",
    "Aeronautical Engineering (AE)",
    "Aerospace Engineering",
    "Apparel Manufacturing and Technology (AMT)",
    "Applied Physics, Electronics and Communication Engineering (APECE)",
    "Bangladesh Studies",
    "Human Rights Law",
    "English for Speakers of Other Languages (ESOL)",
    "Garments Design And Pattern Making Technology",
    "Nutrition and Food Engineering (NFE)",
    "Structural Engineering",
    "Graphic Design and Multimedia (GDM)",
    "Gynecology",
    "Apparel Engineering (AE)",
    "Electrical Electronic and Communication Engineering (EECE)",
    "Control, Microsystems, Microelectronics (CMM)",
    "Human Resource Management (HRM) and Supply Chain Management (Double Major)",
    "Electrical Mechatronics (EM)",
    "Medicine and Surgery",
    "Disaster Management and Resilience (DMR)",
    "Bangladesh MHM School",
    "Population Science and Human Resource Development (PSHRD)",
    "Forestry and Environmental Science",
    "Archaeology",
    "Dyes and Chemical Engineering (DCE)",
    "Human Resource Management (HRM) and Marketing (Double Major)",
    "Human Resource Management (HRM) and Accounting (Double Major)",
    "International Business (IB) and Marketing (Double Major)",
    "Computer and Information System (CIS)",
    "English Language and Literature (ELL)",
    "Inorganic Chemistry",
    "Quranic Sciences and Islamic Studies (QSIS)",
    "French Language and Culture (FLC)",
    "Population and Public Health Sciences (PPHS)",
    "Fisheries and Marine Resources Technology",
    "Coastal and Marine Science",
    "Electro-Medical Technology (EMT)",
    "Textile Engineering and Management",
    "Computer Science and Telecommunication Engineering",
    "History and Civilization",
    "Linguistics",
    "Textile Engineering (Fashion and Design)",
    "Computer and Communication Engineering (CCE)",
    "Development Economics",
    "Knitwear Industry Management",
    "Agribusiness Management",
    "Bioinformatics Engineering",
    "Information Technology and Management (ITM)",
    "Mechanical Technology",
    "Nursing Science and Midwifery",
    "Nursing",
    "Science, Mathematics and Technology Education (SMTE)",
    "Arabic Language and Literature",
    "Arabic Studies",
    "Population Sciences",
    "Apparel Merchandising Management and Technology",
    "Biomedical Science",
    "Environmental Health and Safety",
    "Audiology and Speech Language Pathology (ASLP)",
    "Marine Fisheries",
    "English Language and Linguistics",
    "English and Modern Languages",
    "Health Technology",
    "Construction Engineering",
    "Aeronautical and Aviation Science & Engineering",
    "Microbiology and Immunology",
    "Special and Inclusive Education",
    "Public Health Administration",
    "Quranic Crioncos and Islamic Studios",
    "Earth and Ocean Science",
    "Energy Science and Engineering (ESE)",
    "Pali and Buddhist Studies",
    "Civil and Geotechnical Engineering",
    "Aviation Law",
    "Geotechnical Engineering",
    "Islamic Finance",
    "English Language Teaching and Applied Linguistics",
    "Mathematical and Physical Sciences (MPS)",
    "Banking",
    "Laboratory Technology",
    "Leather Engineering and Technology",
    "Science",
    "Biological Data Science",
    "Business Information Technology",
    "Energy Technology and Management",
    "Applied Statistics",
    "Apparel Manufacturing Management and Technology (AMMT)",
    "Environmental Science and Disaster Management (ESDM)",
    "Clinical Psychology",
    "Mechanical Engineering/Mechatronics (MEng)",
    "General Mechanics",
    "Garment Business (GB)",
    "Applied and Computational Mathematics (ACM)",
    "Apparel Merchandising and Management (AMM)",
    "Dawah and Islamic Studies (DIS)",
    "Bioinformatics in Biotechnology",
    "Bangla",
    "Computer Operation and Maintenance",
    "Sciences of Hadith and Islamic Studies (SHIS)",
  ];
  const handleInputChangeSubjectsHons = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });

    if (value === "") {
      setDropdownVisibleSubjectsHons(false);
    } else {
      setDropdownVisibleSubjectsHons(true);
    }
  };

  const handleOptionClickSubjectsHons = (option) => {
    setFormData({ ...formData, HonsMajor: option });
    setDropdownVisibleSubjectsHons(false); // Hide dropdown after selection
  };

  const filteredOptionsSubjectsHons =
    formData.HonsMajor === ""
      ? []
      : optionsSubjectsHons.filter((option) =>
          option.toLowerCase().includes(formData.HonsMajor.toLowerCase())
        );

  ///////////// subjects Hons

  const [dropdownVisibleSubjectsMasters, setDropdownVisibleSubjectsMasters] =
    useState(false);
  const optionsSubjectsMasters = [
    "Automobile",
    "Petroleum and Mining Engineering",
    "Fabric Manufacturing",
    "Power Supply",
    "Electronics & Communication Engineering (ECE)",
    "Agricultural Chemistry",
    "Home Economics",
    "Disaster Management",
    "Dentistry",
    "Fisheries and Aquaculture",
    "English Literature",
    "Agricultural Engineering and Technology",
    "Printing and Publication Studies",
    "Telecommunication Engineering",
    "English and Humanities",
    "Dance",
    "Music",
    "Physical Education and Sports Science",
    "Art and Creative Studies",
    "Software Engineering (SWE)",
    "Computer Technology",
    "Psychology",
    "Data Telecommunication and Networking",
    "Al-Quran",
    "Industrial Relations and Labour Studies",
    "Agronomy",
    "Geography",
    "Leather Engineering",
    "Plant Pathology",
    "Islamic History and Culture",
    "Agriculture",
    "Pharmaceutical Chemistry",
    "LLM",
    "English Language Teaching (ELT)",
    "Computer Science (CS)",
    "Applied Accounting",
    "Craft",
    "Bank Management",
    "Naval Architecture and Marine Engineering (NAME)",
    "Arabic",
    "Literature and Culture Studies",
    "Fisheries",
    "Electrical and Electronic Engineering (EEE)",
    "Electronics Technology",
    "Instrumental Music",
    "Climate Change and Development (CCD)",
    "Fisheries Science",
    "History",
    "Electronics",
    "Food and Nutrition",
    "Social Science",
    "Social Work",
    "Health Economics",
    "Peace and Conflict Studies",
    "Theoretical Physics",
    "Management Information Systems (MIS)",
    "Computer Engineering (CoE)",
    "Resource Management and Entrepreneurship",
    "Graphic Design",
    "Maritime Science",
    "Pharmaceutical Technology",
    "Entrepreneurship",
    "Anthropology",
    "Nuclear Engineering",
    "Organic Chemistry",
    "Sculpture",
    "Applied Chemistry and Chemical Engineering",
    "English Literature and Language",
    "Geography and Environment",
    "Public Health",
    "Geography and Environmental Studies",
    "Media Studies and Journalism",
    "Theoretical and Computational Chemistry",
    "Electronics and Telecommunication Engineering (ETE)",
    "English",
    "ACCA (the Association of Chartered Certified Accountants)",
    "Law and Justice",
    "Finance and Banking",
    "Pharmacology",
    "Industrial and Production Engineering (IPE)",
    "Oceanography",
    "Applied Mathematics",
    "Soil Science",
    "Business Studies",
    "Criminology",
    "Public Administration",
    "Chemistry",
    "Banking and Insurance",
    "Mathematics",
    "Sociology",
    "Geology",
    "Management",
    "Political Science",
    "Human Resource Management (HRM)",
    "Humanities",
    "Cachion Docianing and Technology",
    "Oriental Art",
    "Architecture",
    "International Relations (IR)",
    "Child Development and Social Relationship",
    "Supply Chain Management",
    "Civil Technology",
    "Shipbuilding Technology",
    "Arabic Language",
    "Hadith",
    "Fashion Designing and Technology (FDT)",
    "Physics",
    "Biochemistry",
    "Japanese Studies",
    "Information and Communication Engineering (ICE)",
    "Information and Communication Technology (ICT)",
    "Rabindra Sangeet",
    "ACCA",
    "Printmaking",
    "Agricultural Economics",
    "Economics",
    "Aeronautical Engineering",
    "Law",
    "Mechanical Engineering (ME)",
    "Building Engineering and Construction Management",
    "Physiotherapy",
    "Power Technology",
    "General",
    "Public Health and Informatics",
    "Accounting and Information Systems (AIS)",
    "Sanskrit",
    "Civil and Environmental Engineering (CEE)",
    "Microbiology",
    "Finance",
    "Nazrul Sangeet",
    "Statistics",
    "Apparel Manufacture and Technology (AMT)",
    "Marine Science",
    "Drawing and Painting",
    "Glass and Ceramic Engineering (GCE)",
    "Apparel Merchandising Management & Technology",
    "Education and Research (ER)",
    "Organization Strategy and Leadership (OSL)",
    "Tourism and Hospitality Management (THM)",
    "International Business (IB)",
    "World Religion and Culture (WRC)",
    "Theater and Music",
    "Languages and Linguistics",
    "Sanskrit and Pali",
    "Port Management and Logistics (PML)",
    "Disaster and Human Security Management (DHSM)",
    "Clothing and Textile",
    "Materials Science and Engineering (MSE)",
    "LLB",
    "Development Studies",
    "Information Technology (IT)",
    "Accounting",
    "Marketing",
    "Marine Tourism and Hospitality Management (MTHM)",
    "Maritime Law (ML)",
    "Port & Shipping Management (PSM)",
    "Environmental Technology Engineering (ETE)",
    "Materials and Metallurgical Engineering (MME)",
    "Disaster Resilience and Sustainable Development (DRSD)",
    "Electronic and Telecom Engineering (ETE)",
    "Environmental Science and Management (ESM)",
    "Environmental and Resource Management (ERM)",
    "Nuclear Power Engineering (NPE)",
    "Disaster Prevention and Urban Safety (DPUS)",
    "Water and Flood Management (WFM)",
    "Communication Disorders",
    "Mass Communication and Journalism (MCJ)",
    "Biomedical Physics and Technology (BPT)",
    "Clinical Pharmacy and Pharmacology (CPP)",
    "Pharmacy",
    "History of Art",
    "Dobotics and Mechatronics",
    "Civil Engineering (CE)",
    "Urban and Rural Planning (URP)",
    "Urban and Regional Planning (URP)",
    "Architecture & Interior Design Technology (AIDT)",
    "Architecture (Arch)",
    "Meteorology",
    "Geography and Environmental Science (GES)",
    "Television, Film and Photography",
    "Disaster Management and Vulnerability Studies (DMVS)",
    "Disaster Science and Management (DSM)",
    "Disaster Science & Management (DSM)",
    "Electromedical Engineering",
    "Electrical & Power Engineering (EPE)",
    "Energy Technology",
    "Naval Architecture and Offshore Engineering (NAOE)",
    "Robotics and Mechatronics Engineering (RME)",
    "Nuclear Science and Engineering (NSE)",
    "Educational Psychology",
    "Plant Breeding",
    "Genetic Engineering and Biotechnology (GEB)",
    "Medical Psychology",
    "Biochemistry and Molecular Biology (BMB)",
    "Petroleum and Mineral Resources Engineering (PMRE)",
    "Craft and Material Studies (CMS)",
    "Materials and Metallurgical Engineering (MME)",
    "Chemical Engineering (ChE)",
    "Mechanical and Chemical Engineering (MCE)",
    "Biomedical Engineering (BME)",
    "Water Resources Engineering (WRE)",
    "Computer Science and Engineering (CSE)",
    "Veterinary Medicine",
    "Agribusiness",
    "Textile Engineering (TE)",
    "Pathology",
    "Forensic Medicine",
    "Community Medicine",
    "Physiology",
    "Anatomy",
    "Mechatronics Engineering (ME)",
    "Classical Music",
    "Radiography",
    "Biochemistry and Biotechnology",
    "Folk Music",
    "Leather Products Engineering",
    "Recourse Management and Entrepreneurship (RME)",
    "Electronic and Telecom Engineering",
    "Biochemistry and Microbiology",
    "Alema",
    "Islamic Studies",
    "Mawlana",
    "Physical Science",
    "Soil, Water and Environment",
    "Finance and Marketing (Double Major)",
    "Zoology",
    "Takmil",
    "Computer Crionco and Insincorina",
    "Interior Architecture",
    "Building Engineering and Construction Management (BECM)",
    "Mechanical and Production Engineering (MPE)",
    "Fabric Engineering",
    "Marhalatul Mutawassitah",
    "Marhala Sanabiah Ulaiya",
    "Marhalatul Fadilat",
    "Geological Sciences",
    "Petroleum & Mining Engineering (PME)",
    "Hifzul Quran",
    "Mufti",
    "Dinajpur Zilla School",
    "Theology and Islamic Studies",
    "Chinese Language and Culture",
    "Electronics and Communication Engineering (ECE)",
    "Information Studies and Library Management",
    "Applied Physics, Electronics and Communication Engineering",
    "Environmental Science (ES)",
    "Holy Quran and Sunnah",
    "Industrial Engineering and Management (IEM)",
    "Law and Human Rights",
    "Architecture Technology",
    "French Language",
    "Computer Information Management (CIM) and Accounting",
    "General Electronics",
    "Dress Making",
    "Tafhim-ul-Quran",
    "Business and Technology Management (BTM)",
    "Moallim",
    "Marine Bio-Resource Science",
    "Applied Linguistics",
    "Dawaa and Civilization",
    "Horticulture",
    "North Indian Classical Music",
    "Islamic Law",
    "Botany",
    "Biotechnology",
    "Marine Bio-Resources Science",
    "Apparel Manufacturing and Management (AMM)",
    "Applied Nutrition and Food",
    "Islamic History",
    "Ispahani Public School and College",
    "Apparel Merchandising",
    "Al-Quran and Islamic Studies",
    "Marketing and Management",
    "Information System (MIS)",
    "Management Studies",
    "Genetics and Plant Breeding (GPB)",
    "Finance and Economics (Double Major)",
    "Photography",
    "Tabla",
    "Nanoscience and Nanotechnology",
    "Management Information Systems (MIS) and Finance (Double Major)",
    "Architecture and Interior Design Technology",
    "Management and Marketing (Double Major)",
    "Management of Technology (MOT)",
    "Computer",
    "Agrotechnology",
    "Agroforestry and Environmental Science",
    "Earth and Environmental Science (EES)",
    "Applied Statistics and Data Science (MSDS)",
    "Electrical Technology",
    "Clinical Pharmacy and Molecular Pharmacology",
    "Education",
    "Philosophy",
    "Veterinary and Animal Science",
    "Agribusiness and Marketing",
    "Applied Physics and Electronics (APE)",
    "Finance and Accounting",
    "Agronomy and Agricultural Extension",
    "English Literature and Theory",
    "Industrial-Organizational Psychology",
    "Chemical Engineering and Polymer Science (CEPS)",
    "Textile Machinery Design and Maintenance",
    "Human Resource Management (HRM) and Economics, Double Major",
    "Human Resource Management (HRM)",
    "International Business (IB), Double Major",
    "Electronics and Communication Engineering (ECE) and Applied Physics",
    "Electrical Engineering",
    "Advanced Engineering Management",
    "Finance and Human Resource Management (HRM)",
    "Jamia Arabia Imdadul Uloom",
    "Faridabad Madrasah",
    "Islamic Philology",
    "Biochemistry and Cell Biology",
    "Al-Hadith and Islamic Studies",
    "Telecommunication Technology",
    "Fashion Design and Technology (FDT)",
    "Computer Operation",
    "Java SE-8",
    "Electrical and Computer Engineering (ECE)",
    "Multimedia and Creative Technology (MCT)",
    "Management and Marketing (Double Major)",
    "Environmental and Resource Economics",
    "Strategic International Management",
    "Economics and Marketing (Double Major)",
    "Wet Processing Engineering (WPE)",
    "Finance and Accounting (Double Major)",
    "Cost and Management Accounting",
    "Drama and Dramatics",
    "Spanish Language",
    "Digital Business and Innovation (DBI)",
    "Renewable Energy Technology (RET)",
    "Craft and Fashion Design",
    "Women and Gender Studies",
    "Physical Chemistry",
    "Biotechnology and Genetic Engineering (BGE)",
    "Government and Politics",
    "Refrigeration and Air-Conditioning Technology",
    "Civil and Water Resources Engineering",
    "Industrial Engineering (IE)",
    "Chemical Engineering and Technics",
    "Biotechnology and Genetic Engineering (BTE)",
    "Mechanical and Electrical Engineering (MEE)",
    "Computer and Information Technology",
    "General Science",
    "Entomology",
    "Criminology and Police Science",
    "Arabic Language and Islamic Studies",
    "Modern Nazrana",
    "Film and Television",
    "Footwear Engineering",
    "Common Law",
    "Economics and Banking (EB)",
    "Accounting and Marketing (Double Major)",
    "Applied Physics and Electronic Engineering (APEE)",
    "Aeronautical Engineering (AE)",
    "Aerospace Engineering",
    "Apparel Manufacturing and Technology (AMT)",
    "Applied Physics, Electronics and Communication Engineering (APECE)",
    "Bangladesh Studies",
    "Human Rights Law",
    "English for Speakers of Other Languages (ESOL)",
    "Garments Design And Pattern Making Technology",
    "Nutrition and Food Engineering (NFE)",
    "Structural Engineering",
    "Graphic Design and Multimedia (GDM)",
    "Gynecology",
    "Apparel Engineering (AE)",
    "Electrical Electronic and Communication Engineering (EECE)",
    "Control, Microsystems, Microelectronics (CMM)",
    "Human Resource Management (HRM) and Supply Chain Management (Double Major)",
    "Electrical Mechatronics (EM)",
    "Medicine and Surgery",
    "Disaster Management and Resilience (DMR)",
    "Bangladesh MHM School",
    "Population Science and Human Resource Development (PSHRD)",
    "Forestry and Environmental Science",
    "Archaeology",
    "Dyes and Chemical Engineering (DCE)",
    "Human Resource Management (HRM) and Marketing (Double Major)",
    "Human Resource Management (HRM) and Accounting (Double Major)",
    "International Business (IB) and Marketing (Double Major)",
    "Computer and Information System (CIS)",
    "English Language and Literature (ELL)",
    "Inorganic Chemistry",
    "Quranic Sciences and Islamic Studies (QSIS)",
    "French Language and Culture (FLC)",
    "Population and Public Health Sciences (PPHS)",
    "Fisheries and Marine Resources Technology",
    "Coastal and Marine Science",
    "Electro-Medical Technology (EMT)",
    "Textile Engineering and Management",
    "Computer Science and Telecommunication Engineering",
    "History and Civilization",
    "Linguistics",
    "Textile Engineering (Fashion and Design)",
    "Computer and Communication Engineering (CCE)",
    "Development Economics",
    "Knitwear Industry Management",
    "Agribusiness Management",
    "Bioinformatics Engineering",
    "Information Technology and Management (ITM)",
    "Mechanical Technology",
    "Nursing Science and Midwifery",
    "Nursing",
    "Science, Mathematics and Technology Education (SMTE)",
    "Arabic Language and Literature",
    "Arabic Studies",
    "Population Sciences",
    "Apparel Merchandising Management and Technology",
    "Biomedical Science",
    "Environmental Health and Safety",
    "Audiology and Speech Language Pathology (ASLP)",
    "Marine Fisheries",
    "English Language and Linguistics",
    "English and Modern Languages",
    "Health Technology",
    "Construction Engineering",
    "Aeronautical and Aviation Science & Engineering",
    "Microbiology and Immunology",
    "Special and Inclusive Education",
    "Public Health Administration",
    "Quranic Crioncos and Islamic Studios",
    "Earth and Ocean Science",
    "Energy Science and Engineering (ESE)",
    "Pali and Buddhist Studies",
    "Civil and Geotechnical Engineering",
    "Aviation Law",
    "Geotechnical Engineering",
    "Islamic Finance",
    "English Language Teaching and Applied Linguistics",
    "Mathematical and Physical Sciences (MPS)",
    "Banking",
    "Laboratory Technology",
    "Leather Engineering and Technology",
    "Science",
    "Biological Data Science",
    "Business Information Technology",
    "Energy Technology and Management",
    "Applied Statistics",
    "Apparel Manufacturing Management and Technology (AMMT)",
    "Environmental Science and Disaster Management (ESDM)",
    "Clinical Psychology",
    "Mechanical Engineering/Mechatronics (MEng)",
    "General Mechanics",
    "Garment Business (GB)",
    "Applied and Computational Mathematics (ACM)",
    "Apparel Merchandising and Management (AMM)",
    "Dawah and Islamic Studies (DIS)",
    "Bioinformatics in Biotechnology",
    "Bangla",
    "Computer Operation and Maintenance",
    "Sciences of Hadith and Islamic Studies (SHIS)",
  ];
  const handleInputChangeSubjectsMasters = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });

    if (value === "") {
      setDropdownVisibleSubjectsMasters(false);
    } else {
      setDropdownVisibleSubjectsMasters(true);
    }
  };

  const handleOptionClickSubjectsMasters = (option) => {
    setFormData({ ...formData, MastersMejor: option });
    setDropdownVisibleSubjectsMasters(false); // Hide dropdown after selection
  };

  const filteredOptionsSubjectsMasters =
    formData.MastersMejor === ""
      ? []
      : optionsSubjectsMasters.filter((option) =>
          option.toLowerCase().includes(formData.MastersMejor.toLowerCase())
        );

  if (!isVisible) return null; // Render nothing if the modal is not visible

  return (
    <div
      className="fixed inset-0  bg-opacity-75 flex justify-center items-center z-50 "
      style={{ backdropFilter: "blur(5px)" }}
    >
      <div className="bg-white rounded-lg shadow-custom-full w-[900px]   mx-5">
        <div className="flex  justify-between py-3 px-5 items-center border-b shadow-md border-green-300">
          <h1 className="text-green-900 lg:text-xl sm:text-md font-montserrat modalTitle">
            Tuition Related Information
          </h1>
          <button
            onClick={onClose}
            className="w-8 h-8 rounded-full flex justify-center items-center "
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-8 w-8"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M6 18L18 6M6 6l12 12"
              />
            </svg>
          </button>
        </div>

        <div className=" bg-green-100 overflow-auto  lg:h-[600px] sm:h-[350px]">
          {profileData.map((profile) => (
            <div className="px-5 py-5">
              <h1 className="text-xl text600 font-montserrat text-green-600">
                SSC/Equivalent
              </h1>

              <div className="grid lg:grid-cols-2 sm:grid-cols-1 gap-5">
                <div className="mt-5">
                  <div className="text-green-900 text-md font-montserrat text600">
                    Group *
                  </div>

                  <select
                    value={formData.SSCgroup}
                    name="SSCgroup"
                    onChange={handleInputChange}
                    className="input border border-green-900 rounded h-12 font-montserrat mt-2 w-full "
                  >
                    <option disabled selected>
                      {profile.SSCgroup}
                    </option>
                    <option value="science">science</option>
                    <option value="arts">arts</option>
                    <option value="commerce">commerce</option>
                  </select>
                  {!isSSCgroupValid && (
                    <div className="text-red-500 text-sm mt-1 textAlert">
                      SSC sroup is required
                    </div>
                  )}
                </div>
                <div className="mt-5">
                  <div className="text-green-900 text-md font-montserrat text600">
                    Institute Name
                  </div>
                  <input
                    type="text"
                    value={formData.SSCinstitute}
                    name="SSCinstitute"
                    placeholder={profile.SSCinstitute}
                    className="input border border-green-900 rounded h-12 font-montserrat mt-2 w-full "
                    onChange={handleInputChange}
                  />
                </div>
              </div>
              <h1 className="mt-16 text-xl text600 font-montserrat text-green-600">
                HSC/Equivalent
              </h1>

              <div className="grid lg:grid-cols-2 sm:grid-cols-1 gap-5 mt-5">
                <div>
                  <div className="text-green-900 text-md font-montserrat text600">
                    Group *
                  </div>

                  <select
                    value={formData.HSCgroup}
                    name="HSCgroup"
                    onChange={handleInputChange}
                    className="input border border-green-900 rounded h-12 font-montserrat mt-2 w-full "
                  >
                    <option disabled selected>
                      {profile.HSCgroup}
                    </option>
                    <option value="science">science</option>
                    <option value="arts">arts</option>
                    <option value="commerce">commerce</option>
                  </select>
                  {!isHSCgroupValid && (
                    <div className="text-red-500 text-sm mt-1 textAlert">
                      HSC group is required
                    </div>
                  )}
                </div>
                <div className="relative">
                  <div className="text-green-900 text-md font-montserrat text600">
                    Institute Name
                  </div>

                  <div>
                    <input
                      type="text"
                      name="HSCinstitute"
                      value={formData.HSCinstitute}
                      placeholder={profile.HSCinstitute}
                      className="input border border-green-900 rounded h-12 font-montserrat mt-2 w-full"
                      onChange={handleInputChangeTwo}
                    />
                    {/* {dropdownVisible && (
                      <div className="dropdown-menu  absolute z-10 mt-2 w-full bg-white border border-orange-400 rounded-lg p-5">
                        {filteredOptions.map((option, index) => (
                          <div
                            key={index}
                            className="dropdown-item py-2 w-full rounded hover:bg-orange-50 pl-2"
                            onClick={() => handleOptionClick(option)}
                            style={{ cursor: "pointer" }}
                          >
                            {option}
                          </div>
                        ))}
                      </div>
                    )} */}
                  </div>
                </div>

                <div>
                  <div className="text-green-900 text-md font-montserrat text600">
                    Passing Result *
                  </div>
                  <input
                    type="number"
                    name="HSCresult"
                    value={formData.HSCresult}
                    placeholder={profile.HSCresult}
                    className="input border border-green-900 rounded h-12 font-montserrat mt-2 w-full "
                    onChange={handleInputChange}
                  />
                  {!isHSCresultValid && (
                    <div className="text-red-500 text-sm mt-1 textAlert">
                      HSC result is required
                    </div>
                  )}
                </div>
                <div>
                  <div className="text-green-900 text-md font-montserrat text600">
                    Certificate / ID Card / Others
                  </div>

                  <div className="border mt-2 border-green-900 rounded h-12  bg-white items-center font-montserrat text-green-600 flex justify-between px-5">
                    <div>
                      <input
                        type="file"
                        id="fileInput"
                        accept=".pdf, .jpg, .jpeg, .png, .gif, .mp4, .webm"
                        onChange={handleFileChange}
                        style={{ display: "none" }}
                        multiple
                      />
                      <button
                        onClick={() =>
                          document.getElementById("fileInput").click()
                        }
                      >
                        <h1 className="font-semibold text-sm" id="fileLabel">
                          JPG / PNG / PDF
                        </h1>
                      </button>
                    </div>
                    <div className="flex justify-between items-center">
                      <button
                        onClick={() =>
                          document.getElementById("fileInput").click()
                        }
                      >
                        <img
                          className="w-5"
                          alt=""
                          src="data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZlcnNpb249IjEuMSIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHdpZHRoPSI1MTIiIGhlaWdodD0iNTEyIiB4PSIwIiB5PSIwIiB2aWV3Qm94PSIwIDAgNTEyIDUxMiIgc3R5bGU9ImVuYWJsZS1iYWNrZ3JvdW5kOm5ldyAwIDAgNTEyIDUxMiIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSIgY2xhc3M9IiI+PGc+PHBhdGggZD0iTTQ5MiAyMzZIMjc2VjIwYzAtMTEuMDQ2LTguOTU0LTIwLTIwLTIwcy0yMCA4Ljk1NC0yMCAyMHYyMTZIMjBjLTExLjA0NiAwLTIwIDguOTU0LTIwIDIwczguOTU0IDIwIDIwIDIwaDIxNnYyMTZjMCAxMS4wNDYgOC45NTQgMjAgMjAgMjBzMjAtOC45NTQgMjAtMjBWMjc2aDIxNmMxMS4wNDYgMCAyMC04Ljk1NCAyMC0yMHMtOC45NTQtMjAtMjAtMjB6IiBmaWxsPSIjMDA4MDAwIiBvcGFjaXR5PSIxIiBkYXRhLW9yaWdpbmFsPSIjMDAwMDAwIiBjbGFzcz0iIj48L3BhdGg+PC9nPjwvc3ZnPg=="
                        />
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <h1 className="mt-16 text-xl text600 font-montserrat text-green-600">
                Honors/Diploma
              </h1>

              <div className="grid lg:grid-cols-2 sm:grid-cols-1 gap-5 mt-5">
                <div className="relative">
                  <div className="text-green-900 text-md font-montserrat text600">
                    Hons Institute *
                  </div>

                  <div>
                    <input
                      type="text"
                      name="HonsInstitute"
                      value={formData.HonsInstitute}
                      placeholder={profile.HonsInstitute}
                      className="input border border-green-900 rounded h-12 font-montserrat mt-2 w-full"
                      onChange={handleInputChangeUniversityHons}
                    />
                    {/* {dropdownVisibleUniversityHons && (
                      <div className="dropdown-menu absolute z-10 mt-2 w-full bg-white border border-orange-400 rounded-lg p-5">
                        {filteredOptionsUniversityHons.map((option, index) => (
                          <div
                            key={index}
                            className="dropdown-item py-2 w-full rounded hover:bg-orange-50 pl-2"
                            onClick={() =>
                              handleOptionClickUniversityHons(option)
                            }
                            style={{ cursor: "pointer" }}
                          >
                            {option}
                          </div>
                        ))}
                      </div>
                    )} */}
                    {!isHonsInstituteValid && (
                      <div className="text-red-500 text-sm mt-1 textAlert">
                        Hons Institute is required
                      </div>
                    )}
                  </div>
                </div>
                <div>
                  <div className="text-green-900 text-md font-montserrat text600">
                    Semester *
                  </div>
                  <input
                    type="number"
                    name="HonsSemester"
                    value={formData.HonsSemester}
                    placeholder={profile.HonsSemester}
                    className="input border border-green-900 rounded h-12 font-montserrat mt-2 w-full "
                    onChange={handleInputChange}
                  />
                  {!isHonsSemesterValid && (
                    <div className="text-red-500 text-sm mt-1 textAlert">
                      Hons Semester is required
                    </div>
                  )}
                </div>
                <div className="relative">
                  <div className="text-green-900 text-md font-montserrat text600">
                    Major / Subject *
                  </div>

                  <div>
                    <input
                      type="text"
                      name="HonsMajor"
                      value={formData.HonsMajor}
                      placeholder={profile.HonsMajor}
                      className="input border border-green-900 rounded h-12 font-montserrat mt-2 w-full"
                      onChange={handleInputChangeSubjectsHons}
                    />
                    {/* {dropdownVisibleSubjectsHons && (
                      <div className="dropdown-menu  absolute z-10 mt-2 w-full bg-white border border-orange-400 rounded-lg p-5">
                        {filteredOptionsSubjectsHons.map((option, index) => (
                          <div
                            key={index}
                            className="dropdown-item py-2 w-full rounded hover:bg-orange-50 pl-2"
                            onClick={() =>
                              handleOptionClickSubjectsHons(option)
                            }
                            style={{ cursor: "pointer" }}
                          >
                            {option}
                          </div>
                        ))}
                      </div>
                    )} */}
                    {!isHonsMajorValid && (
                      <div className="text-red-500 text-sm mt-1 textAlert">
                        Hons Mejor is required
                      </div>
                    )}
                  </div>
                </div>
                {/* <div>
                <div className="text-green-900 text-md font-montserrat text600">
                  Major / Subject
                </div>
                <input
                  type="text"
                  name="HonsMajor"
                  value={formData.HonsMajor}
                  placeholder="type here"
                  className="input border border-green-900 rounded h-12 font-montserrat mt-2 w-full "
                  onChange={handleInputChange}
                />
              </div> */}
                <div>
                  <div className="text-green-900 text-md font-montserrat text600">
                    Certificate / ID Card / Others
                  </div>

                  <div className="border mt-2 border-green-900 rounded h-12  bg-white items-center font-montserrat text-green-600 flex justify-between px-5">
                    <div className="">
                      <input
                        type="file"
                        id="honsFiles"
                        accept=".pdf, .jpg, .jpeg, .png, .gif, .mp4, .webm"
                        onChange={handleFileChangeHons}
                        style={{ display: "none" }}
                        multiple
                      />
                      <button
                        onClick={() =>
                          document.getElementById("honsFiles").click()
                        }
                      >
                        <h1
                          className="font-semibold text-sm"
                          id="honsFileLabel"
                        >
                          JPG / PNG / PDF
                        </h1>
                      </button>
                    </div>
                    <div className="flex justify-between items-center">
                      <button
                        onClick={() =>
                          document.getElementById("honsFiles").click()
                        }
                      >
                        <img
                          className="w-5"
                          alt=""
                          src="data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZlcnNpb249IjEuMSIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHdpZHRoPSI1MTIiIGhlaWdodD0iNTEyIiB4PSIwIiB5PSIwIiB2aWV3Qm94PSIwIDAgNTEyIDUxMiIgc3R5bGU9ImVuYWJsZS1iYWNrZ3JvdW5kOm5ldyAwIDAgNTEyIDUxMiIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSIgY2xhc3M9IiI+PGc+PHBhdGggZD0iTTQ5MiAyMzZIMjc2VjIwYzAtMTEuMDQ2LTguOTU0LTIwLTIwLTIwcy0yMCA4Ljk1NC0yMCAyMHYyMTZIMjBjLTExLjA0NiAwLTIwIDguOTU0LTIwIDIwczguOTU0IDIwIDIwIDIwaDIxNnYyMTZjMCAxMS4wNDYgOC45NTQgMjAgMjAgMjBzMjAtOC45NTQgMjAtMjBWMjc2aDIxNmMxMS4wNDYgMCAyMC04Ljk1NCAyMC0yMHMtOC45NTQtMjAtMjAtMjB6IiBmaWxsPSIjMDA4MDAwIiBvcGFjaXR5PSIxIiBkYXRhLW9yaWdpbmFsPSIjMDAwMDAwIiBjbGFzcz0iIj48L3BhdGg+PC9nPjwvc3ZnPg=="
                        />
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <h1 className="mt-16 text-xl text600 font-montserrat text-green-600">
                Masters
              </h1>

              <div className="grid lg:grid-cols-2 sm:grid-cols-1 gap-5 mt-5">
                <div className="relative">
                  <div className="text-green-900 text-md font-montserrat text600">
                    Masters Institute
                  </div>

                  <div>
                    <input
                      type="text"
                      name="MastersInstitute"
                      value={formData.MastersInstitute}
                      placeholder={profile.MastersInstitute}
                      className="input border border-green-900 rounded h-12 font-montserrat mt-2 w-full"
                      onChange={handleInputChangeUniversityMasters}
                    />
                    {/* {dropdownVisibleUniversityMasters && (
                      <div className="dropdown-menu  absolute z-10 mt-2 w-full bg-white border border-orange-400 rounded-lg p-5">
                        {filteredOptionsUniversityMasters.map(
                          (option, index) => (
                            <div
                              key={index}
                              className="dropdown-item py-2 w-full rounded hover:bg-orange-50 pl-2"
                              onClick={() =>
                                handleOptionClickUniversityMasters(option)
                              }
                              style={{ cursor: "pointer" }}
                            >
                              {option}
                            </div>
                          )
                        )}
                      </div>
                    )} */}
                  </div>
                </div>

                <div>
                  <div className="text-green-900 text-md font-montserrat text600">
                    Semester
                  </div>
                  <input
                    type="number"
                    name="MastersSemester"
                    value={formData.MastersSemester}
                    placeholder={profile.MastersSemester}
                    className="input border border-green-900 rounded h-12 font-montserrat mt-2 w-full "
                    onChange={handleInputChange}
                  />
                </div>
                <div className="relative">
                  <div className="text-green-900 text-md font-montserrat text600">
                    Major / Subject
                  </div>

                  <div>
                    <input
                      type="text"
                      name="MastersMejor"
                      value={formData.MastersMejor}
                      placeholder={profile.MastersMejor}
                      className="input border border-green-900 rounded h-12 font-montserrat mt-2 w-full"
                      onChange={handleInputChangeSubjectsMasters}
                    />
                    {/* {dropdownVisibleSubjectsMasters && (
                      <div className="dropdown-menu w-full absolute z-10 mt-2  bg-white border border-orange-400 rounded-lg p-5">
                        {filteredOptionsSubjectsMasters.map((option, index) => (
                          <div
                            key={index}
                            className="dropdown-item py-2 w-full rounded hover:bg-orange-50 pl-2"
                            onClick={() =>
                              handleOptionClickSubjectsMasters(option)
                            }
                            style={{ cursor: "pointer" }}
                          >
                            {option}
                          </div>
                        ))}
                      </div>
                    )} */}
                  </div>
                </div>
                {/* <div>
                <div className="text-green-900 text-md font-montserrat text600">
                  Major / Subject
                </div>
                <input
                  type="text"
                  value={formData.MastersMejor}
                  name="MastersMejor"
                  placeholder="type here"
                  className="input border border-green-900 rounded h-12 font-montserrat mt-2 w-full "
                  onChange={handleInputChange}
                />
              </div> */}
                <div>
                  <div className="text-green-900 text-md font-montserrat text600">
                    Certificate / ID Card / Others
                  </div>

                  <div className="border mt-2 border-green-900 rounded h-12  bg-white items-center font-montserrat text-green-600 flex justify-between px-5">
                    <div>
                      <input
                        type="file"
                        id="DegreeFiles"
                        accept=".pdf, .jpg, .jpeg, .png, .gif, .mp4, .webm"
                        onChange={handleFileChangeDegree}
                        style={{ display: "none" }}
                        multiple
                      />
                      <button
                        onClick={() =>
                          document.getElementById("DegreeFiles").click()
                        }
                      >
                        <h1
                          className="font-semibold text-sm"
                          id="DegreeFileLabel"
                        >
                          JPG / PNG / PDF
                        </h1>
                      </button>
                    </div>
                    <div className="flex justify-between items-center">
                      <button
                        onClick={() =>
                          document.getElementById("DegreeFiles").click()
                        }
                      >
                        <img
                          className="w-5"
                          alt=""
                          src="data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZlcnNpb249IjEuMSIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHdpZHRoPSI1MTIiIGhlaWdodD0iNTEyIiB4PSIwIiB5PSIwIiB2aWV3Qm94PSIwIDAgNTEyIDUxMiIgc3R5bGU9ImVuYWJsZS1iYWNrZ3JvdW5kOm5ldyAwIDAgNTEyIDUxMiIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSIgY2xhc3M9IiI+PGc+PHBhdGggZD0iTTQ5MiAyMzZIMjc2VjIwYzAtMTEuMDQ2LTguOTU0LTIwLTIwLTIwcy0yMCA4Ljk1NC0yMCAyMHYyMTZIMjBjLTExLjA0NiAwLTIwIDguOTU0LTIwIDIwczguOTU0IDIwIDIwIDIwaDIxNnYyMTZjMCAxMS4wNDYgOC45NTQgMjAgMjAgMjBzMjAtOC45NTQgMjAtMjBWMjc2aDIxNmMxMS4wNDYgMCAyMC04Ljk1NCAyMC0yMHMtOC45NTQtMjAtMjAtMjB6IiBmaWxsPSIjMDA4MDAwIiBvcGFjaXR5PSIxIiBkYXRhLW9yaWdpbmFsPSIjMDAwMDAwIiBjbGFzcz0iIj48L3BhdGg+PC9nPjwvc3ZnPg=="
                        />
                      </button>
                    </div>
                  </div>
                </div>
              </div>

            
            </div>
          ))}
        </div>
        <div className="flex px-5">
                <div>
                  {loading ? (
                    <button
                      onClick={handleUpload}
                      className="lg:w-32 sm:w-20 h-10 flex justify-center items-center bg-green-700 font-montserrat text-white rounded my-5"
                    >
                      <LoaderSmall />
                    </button>
                  ) : (
                    // Show the loader when uploading
                    <button
                      onClick={handleUpload}
                      className="lg:w-32 sm:w-20 h-10 flex justify-center items-center bg-green-700 font-montserrat text-white rounded my-5"
                    >
                      SUBMIT
                    </button>
                  )}
                </div>
              </div>
      </div>
    </div>
  );
};

export default ModalEducational;
